import * as z from 'zod'
import { phoneScheme } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const schema = z.object({
  selfEmployedPhone: phoneScheme,
})

export type DriverCreateSelfEmployedEventAttributes = z.infer<typeof schema>

export class DriverCreateSelfEmployedEvent extends ApiModel<
  typeof schema,
  DriverCreateSelfEmployedEventAttributes
> {
  static jsonApiType = 'driver-create-self-employed-events'

  static schema = schema
}
